import { useCallback, useRef } from 'react'
import { LeftSidebarMode } from './Layout1SettingsChtc'

interface StyleDimensions {
  [key: string]: number
}

export const useSidebarDimensions = () => {
  const initialStylesRef = useRef(new Map())
  const sidenavWidthRef = useRef<number | null>(null)

  const getZoomFactor = useCallback(() => {
    return 1 / window.devicePixelRatio
  }, [])

  const updateElementStyles = (
    { element, mode, isResize, isToggleBtnTouched, updateElementStylesCallback, isRoot = true }:
    {
      element: HTMLElement | null
      mode: LeftSidebarMode
      isResize: boolean
      isToggleBtnTouched: boolean
      updateElementStylesCallback?: (zoomFactor: number) => void
      isRoot?: boolean
    }
  ) => {
    if ((element == null) || (!mode && initialStylesRef.current.has(element))) return

    if (element.style && (!mode || (mode !== 'close'))) {
      let initialStyles = initialStylesRef.current.get(element)
      const zoomFactor = getZoomFactor()
      const computedStyle = window.getComputedStyle(element)

      const pixelProperties = [
        'fontSize', 'letterSpacing',
        'width', 'height', 'minWidth', 'minHeight',
        'marginTop', 'marginRight', 'marginBottom', 'marginLeft',
        'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
        'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
        'backgroundSize', 'backgroundPositionX', 'backgroundPositionY'
      ]

      if (!initialStyles) {
        initialStyles = {} as StyleDimensions

        pixelProperties.forEach(prop => {
          const value = computedStyle[prop as keyof CSSStyleDeclaration]
          if (typeof value === 'string' && value.endsWith('px')) {
            initialStyles[prop] = parseFloat(value)

            if (prop === 'height') {
              if (element.classList.contains('scrollbar-container') ||
                element.classList.contains('sidenav') ||
                element.classList.contains('layout1-sidenav') ||
                element.classList.contains('brand-area') ||
                element.classList.contains('sidenav__hold')
              ) {
                initialStyles.height = '100%'
              } else if (element.classList.contains('item-icon') ||
                element.classList.contains('nav-item') ||
                element.classList.contains('company-logo') ||
                element.classList.contains('nav-organisation-error')
              ) {
                initialStyles.height = parseFloat(value)
                initialStyles.minHeight = parseFloat(value)
              } else {
                initialStyles.height = 'auto'
                initialStyles.minHeight = 'auto'
              }
            }
          }
        })

        initialStylesRef.current.set(element, initialStyles)

        setTimeout(() => {
          updateElementStyles({ element, mode, isResize, isToggleBtnTouched, isRoot })
        }, 0)
      } else {
        // Apply zoom factor to all stored pixel values
        Object.entries(initialStyles).forEach(([prop, value]) => {
          const numericValue = value as number
          const zoomedValue = numericValue * zoomFactor

          if (pixelProperties.includes(prop)) {
            if (prop.includes('width') && element.classList.contains('brand__text')) {
              return
            }

            if (prop.includes('width') && element.classList.contains('company-logo') && zoomedValue === 0) {
              return
            }

            (element.style as any)[prop] = `${zoomedValue}px`
            if (element.classList.contains('company-logo')) {
              console.log('qqq', element)
            } else if (element.classList.contains('brand__text')) {
              console.log('qqq2', element)
            }

            if (element.classList.contains('layout1-sidenav') &&
              ((mode === 'full' && !isResize && isToggleBtnTouched)
              ) &&
              prop === 'width'
            ) {
              element.style.width = '0px'
            }
          }
        })
      }
    }

    // Recursively update children
    Array.from(element.children).forEach((child, index) => {
      updateElementStyles({
        element: child as HTMLElement,
        mode,
        isResize,
        isToggleBtnTouched,
        updateElementStylesCallback,
        isRoot: false
      })
    })

    if (isRoot && (updateElementStylesCallback != null)) {
      updateElementStylesCallback(getZoomFactor())
    }
  }

  return {
    updateElementStyles,
    getZoomFactor,
    initialStylesRef
  }
}
